import { LOGGER_LEVEL } from 'b2b-apps/shop/common/utils/logger/logger';
import { ExtrasType, Logger } from 'b2b-apps/shop/common/utils/logger/logger.types';

const consoleLogger: Logger = {
  [LOGGER_LEVEL.log]: (
    message: string,
    extras: ExtrasType = {},
  ) => captureMessage(LOGGER_LEVEL.log, message, extras),
  [LOGGER_LEVEL.info]: (
    message: string,
    extras: ExtrasType = {},
  ) => captureMessage(LOGGER_LEVEL.info, message, extras),
  [LOGGER_LEVEL.warn]: (
    message: string,
    extras: ExtrasType = {},
  ) => captureMessage(LOGGER_LEVEL.warn, message, extras),
  [LOGGER_LEVEL.error]: (
    message: string,
    extras: ExtrasType = {},
  ) => captureMessage(LOGGER_LEVEL.error, message, extras),
  [LOGGER_LEVEL.debug]: (
    message: string,
    extras: ExtrasType = {},
  ) => captureMessage(LOGGER_LEVEL.debug, message, extras),
};

const captureMessage = (
  level: LOGGER_LEVEL,
  message: string,
  extras: ExtrasType = {},
): void => {
  // eslint-disable-next-line no-console
  console[level]({
    message,
    extras,
  });
};

export {
  consoleLogger,
};
